import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import { InputTextarea } from "primereact/inputtextarea";
import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from "../../components/SelecaoAmparoLegal";
import { salvarAutenticacao } from "../../service/CertidaoCompensacao";
import CertidaoView from "./certidaoView";
import { Card } from "primereact/card";
import { buscarCertidaoAtivaLegada } from "../../service/certidao";
import { ErrorOutline, CheckCircleOutline } from "@material-ui/icons";

import "./style.css";
import CardSeplag from "../../components/CardSeplag";
import { InputMask } from "primereact/inputmask";

const ModalAutenticar = (props) => {
  const amparo = useSelecaoAmparoLegal();
  const [certidao, setCertidao] = useState(null);
  const [validaCertidaoLegada, setValidaCertidaoLegada] = useState(null);
  const [existeAutenticacaoLegada, setExisteAutenticacaoLegada] = useState(false);

  const [autenticar, setAutenticar] = useState({
    amparoLegal: "",
    observacao: "",
    dataEventoCertidao: null,
  });

  useEffect(() => {
    buscarCertidaoAtivaLegada(props.certidaoSelected.idenCertidao).then((res) => {
      setCertidao(res.certidao);
      setValidaCertidaoLegada(res.validaCertidaoLegada);
    });
  }, []);

  useEffect(() => {
    if (validaCertidaoLegada && validaCertidaoLegada.dataAutenticCert) {
      setExisteAutenticacaoLegada(true);
    }
  }, [validaCertidaoLegada]);

  const salvarModalAutenticar = () => {
    // let data = new Date();

    let dados = {
      idenCertidao: certidao.idenCertidao,
      descComplemento: autenticar.observacao,
      listaAmparoLegalCertidao: amparo.justificativasSelecionada,
      dataEventoCertidao: autenticar.dataEventoCertidao,
    };

    salvarAutenticacao(dados).then((resAutenticacao) => {
      window.$toast.current.show({ severity: "success", summary: resAutenticacao });
      props.onSalvar && props.onSalvar();
      props.onFechar();
    });
  };

  const handleImportarAutenticacao = () => {
    setAutenticar({
      ...autenticar,
      dataEventoCertidao: validaCertidaoLegada.dataAutenticCert,
      observacao: validaCertidaoLegada.numrProcessoAutenticacao,
    });
  };

  if (!certidao) {
    return <> </>;
  }

  return (
    <ModalSeplag titulo={"Autenticar"} visible={props.visible} fechar={props.onFechar} type="DESBLOQUEAR" funcAcao={salvarModalAutenticar} tamanho="70em" labelAcao={props.tipoAcao}>
      <CertidaoView certidao={certidao} />
      <div className="p-col-12" />
      <CardSeplag>
        {existeAutenticacaoLegada && (
          <div className="p-col-6" style={{ padding: "20px 10px", marginBottom: "15px" }} onClick={handleImportarAutenticacao}>
            <Card
              className={`
                           ${validaCertidaoLegada.dataAutenticCert === autenticar.dataEventoCertidao ? "modal-card-importado" : "modal-card"}
                         `}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {validaCertidaoLegada.dataAutenticCert === autenticar.dataEventoCertidao ? <CheckCircleOutline c style={{ color: "#067406", fontSize: "2.2rem", flex: "1" }} /> : <ErrorOutline style={{ color: "#e95c09", fontSize: "2.2rem", flex: "1" }} />}
                <p className="m-0" style={{ lineHeight: "1.5", flex: "13" }}>
                  Existe informação de Data e Nº Processo de Autenticação no LEGADO. Click aqui se deseja importar.
                </p>
              </div>
            </Card>
          </div>
        )}

        <div className={`p-grid ${existeAutenticacaoLegada ? "p-col-5" : "p-col-12"}`}>
          <RotuloSeplag obrigatorio nome="Data do Evento" cols="12">
            <InputMask
              autofocus
              id="date"
              mask="99/99/9999"
              value={autenticar.dataEventoCertidao}
              placeholder="99/99/9999"
              slotChar="mm/dd/yyyy"
              onChange={(e) => setAutenticar({ ...autenticar, dataEventoCertidao: e.target.value })}
            />
          </RotuloSeplag>
          <RotuloSeplag nome="Observação:" cols="12">
            <InputTextarea rows={3} cols={30} value={autenticar.observacao} onChange={(e) => setAutenticar({ ...autenticar, observacao: e.target.value })} />
          </RotuloSeplag>
        </div>
        {validaCertidaoLegada &&
          validaCertidaoLegada.dataAutenticCert &&
          validaCertidaoLegada.dataAutenticCert !== autenticar.dataEventoCertidao && (
            <p className="p-col-12" style={{ textAlign: "center", fontSize: "1rem", fontWeight: 500 }}>
              Não importar, significa que a informação não será mais verificada, permanecendo no LEGADO
            </p>
          )}
      </CardSeplag>
      <SelecaoAmparoLegalRender {...amparo} />
    </ModalSeplag>
  );
};

ModalAutenticar.propTypes = {
  // orgao: PropTypes.array.isRequired,
  // tipoAto: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  onFechar: PropTypes.func.isRequired,
  onSalvar: PropTypes.func,
};

export default ModalAutenticar;
